import React from 'react';
import { render } from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import App from './components/App';
import reducer from './reducers';
import 'todomvc-app-css/index.css';

export const store = createStore(reducer);

window.store = store;

render(
	<Provider store={store}>
		<App />
	</Provider>,
	document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js